import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';

const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const sanitizeFilename = (name) => name.replace(/[^a-zA-Z0-9._-]/g, '_');

export const exportCsv = (rows, filename = 'export.csv') => {
  if (!rows || rows.length === 0) return;
  const headers = Object.keys(rows[0]);
  const csv = [
    headers.join(','),
    ...rows.map((row) =>
      headers.map((key) => JSON.stringify(row[key] ?? '')).join(',')
    ),
  ].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  downloadBlob(blob, sanitizeFilename(filename));
};

export const exportExcel = (rows, filename = 'export.xlsx') => {
  if (!rows || rows.length === 0) return;
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'data');
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  downloadBlob(blob, sanitizeFilename(filename));
};

export const exportPdf = (rows, filename = 'export.pdf', title = 'Exportacion') => {
  if (!rows || rows.length === 0) return;
  const headers = Object.keys(rows[0]);
  const body = rows.map((row) => headers.map((key) => row[key] ?? ''));
  const doc = new jsPDF();
  doc.text(title, 14, 16);
  autoTable(doc, {
    startY: 22,
    head: [headers],
    body,
    styles: { fontSize: 8 },
    headStyles: { fillColor: [24, 24, 27] },
  });
  doc.save(sanitizeFilename(filename));
};
